import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Row,
  Col,
  Input,
  Button
} from "reactstrap";
import axios from "../../../../utills/api";
import { FaTrash } from "react-icons/fa";
import { toast } from "react-toastify";

const API_BASE = "/spa-settings";

const SpaCategoryModal = ({
  isOpen,
  toggle
}) => {

  const [categories, setCategories] = useState([]);
  const [newCategory, setNewCategory] = useState("");

  const token = localStorage.getItem("token");

  const axiosConfig = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const fetchSpaCategories = async () => {
    try {

      const res = await axios.get(
        API_BASE,
        axiosConfig
      );

      setCategories(
        Array.isArray(res.data)
          ? res.data
          : []
      );

    } catch (err) {

      console.error(err);

      toast.error(
        err.response?.data?.message ||
        "Failed to fetch categories"
      );

    }
  };

  useEffect(() => {
    if (isOpen) {
      fetchSpaCategories();
    }
  }, [isOpen]);

  const handleCreateCategory = async () => {

    if (!newCategory.trim()) {
      return toast.error(
        "Enter category name"
      );
    }

    try {

      const res = await axios.post(
        API_BASE,
        {
          name: newCategory.trim(),
        },
        axiosConfig
      );

      setCategories((prev) => [
        ...prev,
        res.data,
      ]);

      setNewCategory("");

      toast.success(
        "Category created successfully"
      );

    } catch (err) {

      console.error(err);

      toast.error(
        err.response?.data?.message ||
        "Failed to create category"
      );

    }
  };

  const handleDeleteCategory = async (
    id
  ) => {

    if (
      !window.confirm(
        "Delete this category?"
      )
    )
      return;

    try {

      await axios.delete(
        `${API_BASE}/${id}`,
        axiosConfig
      );

      setCategories((prev) =>
        prev.filter(
          (cat) => cat._id !== id
        )
      );

      toast.success(
        "Category deleted"
      );

    } catch (err) {

      console.error(err);

      toast.error(
        err.response?.data?.message ||
        "Failed to delete category"
      );

    }
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      size="lg"
    >
      <ModalHeader toggle={toggle}>
        Spa Categories
      </ModalHeader>

      <ModalBody>

        <Row className="mb-4">
          <Col md={8}>
            <Input
              type="text"
              placeholder="Enter spa category"
              value={newCategory}
              onChange={(e) =>
                setNewCategory(
                  e.target.value
                )
              }
            />
          </Col>

          <Col md={4}>
            <Button
              color="success"
              onClick={
                handleCreateCategory
              }
            >
              Create Category
            </Button>
          </Col>
        </Row>

        <Row>

          {categories.length === 0 ? (

            <Col>
              <p className="text-muted">
                No categories found
              </p>
            </Col>

          ) : (

            categories.map((cat) => (
              <Col
                md={4}
                key={cat._id}
                className="mb-3"
              >
                <div
                  className="d-flex justify-content-between align-items-center border rounded p-2"
                >
                  <span>
                    {cat.name}
                  </span>

                  <FaTrash
                    size={14}
                    className="text-danger"
                    style={{
                      cursor: "pointer",
                    }}
                    onClick={() =>
                      handleDeleteCategory(
                        cat._id
                      )
                    }
                  />
                </div>
              </Col>
            ))

          )}

        </Row>

      </ModalBody>
    </Modal>
  );
};

export default SpaCategoryModal;